import { DatePipe, TitleCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { hasImageExtension } from '../../helpers/image.helper';
import {
  CapitalizePipe,
  ReplaceUnderscore,
  TransformCamelCase,
} from '../../pipes';

@Injectable({
  providedIn: 'root',
})
export class CertificateHelperService {
  constructor(
    private capitalize: CapitalizePipe,
    private removeCamelcase: TransformCamelCase,
    private replaceUnderscore: ReplaceUnderscore,
    private titlecase: TitleCasePipe,
    private datePipe: DatePipe
  ) {}

  async receiptObject(data: any) {
    const {
      studentName,
      amount,
      email,
      phoneNumber,
      paymentMode,
      transactionRef,
      fee,
      session,
      term,
      invoiceRef,
      qrCode,
      regNumber,
      updatedAt,
      transactionAmount,
      organization,
    } = data;
    const method =
      paymentMode === 'USSD'
        ? paymentMode
        : this.titlecase.transform(
            this.replaceUnderscore.transform(paymentMode)
          );
    const receiptObj = {
      logo: (await hasImageExtension(organization?.kycDocument?.logo))
        ? organization.kycDocument.logo
        : '',
      qrCode,
      fileName: `${fee?.title || 'payment receipt'}-${transactionRef}`,
      payment: [
        {
          label: 'Purpose of payment',
          value: this.capitalize.transform(fee?.title || 'N/A'),
        },
        {
          label: 'Payment reference',
          value: transactionRef,
        },
        {
          label: 'Payment method',
          value: method,
        },
        {
          label: 'Session ',
          value: `${session} - ${this.titlecase.transform(
            this.removeCamelcase.transform(term)
          )}`,
        },
        {
          label: 'Transaction Date',
          value: this.datePipe.transform(updatedAt, 'MMM d, y, h:mm:ss a'),
        },
      ],
      customer: [
        {
          label: 'Student name',
          value: this.titlecase.transform(
            this.capitalize.transform(studentName)
          ),
        },
        {
          label: 'Registration number',
          value: regNumber,
        },
        {
          label: 'Tranasction email',
          value: email?.toLowerCase(),
        },
        {
          label: 'Transaction phone number',
          value: phoneNumber,
        },
      ],
      beneficairy: [
        {
          label: 'Beneficiary',
          value: this.capitalize.transform(organization.organizationName),
        },
        {
          label: 'Business category',
          value:
            organization.organizationCategory === 'school'
              ? `${this.capitalize.transform(
                  organization.schoolType
                )} ${this.capitalize.transform(
                  organization.organizationCategory
                )} `
              : organization.organizationCategory,
        },
        {
          label: 'Business address',
          value: this.titlecase.transform(organization.address || 'N/A'),
        },
      ],
    };
    return receiptObj;
  }
}
